import type { ShipmentSelections, ShippingState } from "./shipping-api";

type Choices = Partial<ShipmentSelections>;

export const PARCEL_SERVICE_LABELS = {
  ground: "UPS Ground",
  two_day: "2-Day Air",
  next_day: "Next-Day Air",
} as const;

/** What address detection says, for the quote's "Detected" choices. */
export function detectedChoices(shipping: ShippingState): Choices {
  const detected = shipping.address_detection?.destination_type ?? "commercial";
  return {
    destination_type: detected === "residential" ? "residential" : "commercial",
    limited_access: detected === "limited_access",
  };
}

/** What the quote's choices come to with address detection filling the gaps (liftgate stays by weight). */
export function quoteDeliveryChoices(shipping: ShippingState): Choices {
  const defaults = shipping.delivery_defaults ?? {};
  const detected = shipping.address_detection?.destination_type ?? "commercial";
  return {
    ...defaults,
    destination_type:
      defaults.destination_type ??
      (detected === "residential" ? "residential" : "commercial"),
    limited_access:
      defaults.limited_access ?? detected === "limited_access",
    inside_delivery: defaults.inside_delivery ?? false,
    appointment: defaults.appointment ?? false,
    construction_site: defaults.construction_site ?? false,
    has_loading_dock: defaults.has_loading_dock ?? false,
    has_forklift: defaults.has_forklift ?? false,
    parcel_service: defaults.parcel_service ?? "ground",
  };
}

/** A shipment's delivery in a few words, for its summary line. */
export function deliverySummary(
  effective: ShipmentSelections,
  freight: boolean,
): string {
  if (!freight)
    return PARCEL_SERVICE_LABELS[effective.parcel_service ?? "ground"];
  return [
    effective.destination_type === "residential" ? "Residential" : "Commercial",
    effective.limited_access ? "Limited access" : null,
    effective.liftgate ? "Liftgate" : "No liftgate",
    effective.inside_delivery ? "Inside delivery" : null,
    effective.appointment ? "Appointment" : null,
    effective.construction_site ? "Construction site" : null,
    effective.has_loading_dock
      ? "Dock"
      : effective.has_forklift
        ? "Forklift"
        : "No dock or forklift",
  ]
    .filter(Boolean)
    .join(" · ");
}
